import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f28224b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "majorsContainer" }
const _hoisted_2 = { class: "majorsLine1" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "majorsLine2" }

import {ref, reactive, nextTick, onMounted, onBeforeUnmount, watch} from 'vue'
  import {useRouter, useRoute} from "vue-router";
  import {useStore} from "@/store";


  
export default /*#__PURE__*/_defineComponent({
  __name: 'MobileIncludingMajors',
  props: ['majorArray'],
  setup(__props) {

const props = __props;

  let router = useRouter();
  let route = useRoute();
  let store = useStore();
  


  //获取滚动条
  let IncludingMajorsScrollBar = ref();

  let goMajorSituation = (n: any) => {
    let id = ref(props.majorArray[n].majorCode);
    // console.log(id.value)
    router.push('/MobileMajorSituation' + '/' + id.value)
  };

  // let goScrollBar = () => {
  //   nextTick(() => {
  //     IncludingMajorsScrollBar.value.scrollTop = 0;
  //   });
  // };
  //
  // defineExpose({
  //   goScrollBar
  // });

  // 离开页面前
  onBeforeUnmount(() => {
    store.mobileTransferPage = IncludingMajorsScrollBar.value.scrollTop;
  });
  //也面加载时
  onMounted(() => {
    // 异步请求时间延迟导致无法准确设置
    //这个是我真是项目中遇到的，需求在页面刚进去的时候需求实现页面滚动在最底部，
    // 在生命周期函数componentDidMount中我们需要获取到元素并设置scrollTop，问题是后端打日志需要时间，
    // 所以mylist.scrollTop = mylist.scrollHeight并木有执行，当页面加载后，List中所需要的数据还没从后端返回，
    // 无法获取到List的高度（设置scrollTop前提必须是存在滚动条）但是加了定时器之后，后端数据返回并写入dom中，
    // 设置scrollTop值才能生效。
    setTimeout(() => {
      IncludingMajorsScrollBar.value.scrollTop = store.mobileTransferPage;
    }, 30)
  });



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "IncludingMajors",
    ref_key: "IncludingMajorsScrollBar",
    ref: IncludingMajorsScrollBar
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(props).majorArray, (item, i) => {
      return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", {
            onClick: ($event: any) => (_unref(goMajorSituation)(i))
          }, _toDisplayString(item.majors), 9, _hoisted_3)
        ]),
        _createElementVNode("div", _hoisted_4, " 国标代码：" + _toDisplayString(item.majorCode), 1)
      ]))
    }), 256))
  ], 512))
}
}

})